import VoyageValidatorData from "../data";

export default function voyageValidatorDataFromJson(json) {
  return new VoyageValidatorData(
    json.id,
    json.draft,
    json.tss,
    json.service_speed,
    json.cruise_speed,
    json.wind,
    json.wave,
    json.trs,
    json.land_proximity,
  );
}
